const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ============================================================
   ME + LIA — CART NUDGE + INSTRUMENTATION  (2026-07-28, rev 3)

   Loaded on every page via theme.liquid. Everything uses
   DELEGATED listeners on document, so NO edits are needed to
   ml-custom.js (13.7KB minified, 4 rounds of QA baked in) or
   theme.liquid (30KB).

   NOTE: bridge pages use layout/bridge.liquid, which does NOT
   load this file — so the pill simply never exists there. That
   is the desired outcome (bridge pages own their single CTA);
   the .mlbp-sticky check below is belt-and-braces in case a
   bridge page ever renders in the main layout.

   REV 2 FIXES: drawer opens via class 'active' not attribute
   'open'; setInterval was starting twice (deferred script =
   readyState already 'interactive'); collision moved out of
   CSS :has() (unsupported on older iOS in-app webviews) into JS.

   REV 3 FIXES (from Chrome QA):
   d) SUPPRESSED on /cart and /checkout — the cart page already
      has its own Check out button plus Shop Pay/PayPal/GPay;
      the pill was a redundant second CTA stacked in the same
      view, and it covered the "LEARN MORE" link in the First
      Piece Promise box.
   e) HIDES WHEN THE FOOTER IS IN VIEW — QA found it sitting on
      top of the payment icons and the copyright line. Once a
      customer has scrolled to the footer they are at the end of
      the page and the header cart is reachable anyway.
   f) tick interval 400ms -> 150ms, so the hand-off to/from the
      PDP sticky bar no longer shows a visible crossfade where
      both are briefly on screen.
   ============================================================ */
;(function () {
  if (window.__mlNudgeInit) return;
  window.__mlNudgeInit = true;

  /* ---------- Clarity: sticky add-to-cart ---------- */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('#ml-sticky-atc-btn')) {
        try {
          if (window.clarity) window.clarity('event', 'ml_sticky_atc');
        } catch (err) {}
      }
    },
    true
  );

  /* ---------- Zoom modal: close on backdrop tap (desktop only) ---------- */
  document.addEventListener(
    'click',
    function (e) {
      try {
        if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
        var modal = document.querySelector('product-modal[open]');
        if (!modal) return;
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('img, video, iframe, model-viewer, button, a, deferred-media, .ml-emergency-close')) return;
        var dialog = modal.querySelector('.product-media-modal__dialog');
        var content = modal.querySelector('.product-media-modal__content');
        if (t === modal || t === dialog || (content && t === content)) {
          if (typeof modal.hide === 'function') modal.hide();
        }
      } catch (err) {}
    },
    false
  );

  /* ---------- Cart nudge ---------- */
  var PILL_ID = 'ml-cart-nudge';
  var started = false;
  var footerVisible = false;

  /* never run on the cart or checkout pages */
  function onCartOrCheckout() {
    var p = (window.location.pathname || '').toLowerCase();
    return p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/checkouts') === 0;
  }
  if (onCartOrCheckout()) return;

  function money(cents) {
    try {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    } catch (e) {
      return '';
    }
  }

  function ensureStyles() {
    if (document.getElementById('ml-cart-nudge-style')) return;
    var s = document.createElement('style');
    s.id = 'ml-cart-nudge-style';
    s.textContent =
      '#ml-cart-nudge{position:fixed;left:50%;transform:translateX(-50%) translateY(20px);' +
      'bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:2147482000;display:none;' +
      'align-items:center;gap:10px;padding:12px 20px;border-radius:28px;background:#2A2224;' +
      'color:#fff;text-decoration:none;font-family:Karla,sans-serif;font-size:14px;' +
      'font-weight:600;letter-spacing:.04em;box-shadow:0 6px 24px rgba(20,12,14,.28);' +
      'opacity:0;transition:opacity .2s ease,transform .2s ease;cursor:pointer;}' +
      '#ml-cart-nudge.is-visible{display:flex;opacity:1;transform:translateX(-50%) translateY(0);}' +
      '#ml-cart-nudge .ml-cn__count{background:#9E4C58;border-radius:50%;width:22px;height:22px;' +
      'display:inline-flex;align-items:center;justify-content:center;font-size:12px;line-height:1;}' +
      '#ml-cart-nudge .ml-cn__sub{font-weight:400;opacity:.82;font-size:12.5px;letter-spacing:.01em;}' +
      '@media (max-width:749px){#ml-cart-nudge{font-size:13.5px;padding:11px 18px;}}';
    document.head.appendChild(s);
  }

  function pill() {
    var el = document.getElementById(PILL_ID);
    if (el) return el;
    ensureStyles();
    el = document.createElement('a');
    el.id = PILL_ID;
    el.href = '/checkout';
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="ml-cn__count">0</span><span class="ml-cn__label">Checkout</span>' +
      '<span class="ml-cn__sub"></span>';
    el.addEventListener('click', function () {
      try {
        if (window.clarity) window.clarity('event', 'ml_cart_nudge_click');
      } catch (e) {}
    });
    document.body.appendChild(el);
    return el;
  }

  /* watch the footer so the pill never covers payment icons / copyright */
  function watchFooter() {
    try {
      var f = document.querySelector('footer, .footer, #shopify-section-footer');
      if (!f || !window.IntersectionObserver) return;
      new IntersectionObserver(
        function (entries) {
          footerVisible = !!(entries[0] && entries[0].isIntersecting);
        },
        { threshold: 0 }
      ).observe(f);
    } catch (e) {}
  }

  /* Stand down when: cart drawer open (has its own checkout button) /
     PDP sticky add-to-bag on screen / a bridge-style bottom CTA exists /
     the footer is in view. */
  function shouldDefer() {
    try {
      if (footerVisible) return true;
      var d = document.querySelector('cart-drawer');
      if (d && d.classList.contains('active')) return true;
      var sticky = document.getElementById('ml-sticky-atc');
      if (sticky && sticky.classList.contains('is-visible')) return true;
      if (document.querySelector('.mlbp-sticky')) return true;
    } catch (e) {}
    return false;
  }

  function render(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    var el = pill();
    if (count > 0) {
      el.querySelector('.ml-cn__count').textContent = count;
      el.querySelector('.ml-cn__sub').textContent = money(cart.total_price);
      if (!el.classList.contains('is-visible')) {
        el.style.display = 'flex';
        requestAnimationFrame(function () {
          el.classList.add('is-visible');
        });
      }
    } else {
      el.classList.remove('is-visible');
      setTimeout(function () {
        el.style.display = 'none';
      }, 220);
    }
  }

  function refresh() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    fetch(root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(render)
      .catch(function () {});
  }

  function tick() {
    var el = document.getElementById(PILL_ID);
    if (el) el.style.visibility = shouldDefer() ? 'hidden' : 'visible';
  }

  function start() {
    if (started) return;
    started = true;
    watchFooter();
    refresh();
    setInterval(tick, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('.product-form__submit, #ml-sticky-atc-btn, .quick-add__submit, [name="add"]')) {
        setTimeout(refresh, 700);
        setTimeout(refresh, 1600);
      }
    },
    true
  );

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refresh, 200);
      });
    }
  } catch (e) {}

  document.addEventListener('cart:refresh', function () {
    setTimeout(refresh, 200);
  });
})();

/* ============================================================
   ME + LIA — SIZE-ROW VISIBILITY INSTRUMENT (2026-08-03, rev 1)

   WHY: the mobile scroll cliff sits at 20-30% depth, right at
   the bottom of the image gallery, and the SIZE selector is the
   first block below it. Clarity scroll heatmaps can tell us the
   depth but not, per cohort, whether the size row was ever seen.
   This fires two Clarity events so that question is answerable
   directly and split by any Clarity filter (UTM, device, source):

     ml_pdp_view     — every product-page load (the denominator)
     ml_size_visible — the size row actually entered the viewport
     ml_size_absent  — no size pills found (single-variant SKU)

   Read it as: ml_size_visible / ml_pdp_view = share of visitors
   who ever saw the size row. That same ratio is the before/after
   measure for the gallery-height cap, so this must ship and
   collect a baseline BEFORE the cap goes in.

   Custom clarity('event') names appear in the Clarity dashboard
   BY THEMSELVES on first fire — verified Aug 3. Nothing needs
   pre-registering (and in fact cannot be).

   INDUCED-VIEW GUARD: the size gate in product-form.js scrolls
   the shopper up to the pills when they tap ADD TO BAG without
   choosing a size. That is not an organic view, so any tap on an
   add-to-bag control suppresses the event for 1.5s. Because an
   IntersectionObserver only fires on threshold CROSSINGS, a
   suppressed view is simply lost rather than deferred — the
   count therefore undercounts slightly rather than inflating.
   ============================================================ */
;(function () {
  if (window.__mlSizeVisibleInit) return;
  window.__mlSizeVisibleInit = true;

  if ((window.location.pathname || '').indexOf('/products/') === -1) return;
  if (!window.IntersectionObserver) return;

  var SIZE_SEL = '.product-form__input--pill';
  var THRESHOLD = 0.5; /* half the size row on screen, not a sliver */
  var fired = false;
  var suppressed = false;
  var giveUpAt = Date.now() + 10000;

  function clar(name) {
    try {
      if (window.clarity) window.clarity('event', name);
    } catch (e) {}
  }

  /* any add-to-bag tap may trigger the gate's programmatic scroll */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('.product-form__submit, #ml-sticky-atc-btn, [name="add"]')) {
        suppressed = true;
        setTimeout(function () {
          suppressed = false;
        }, 1500);
      }
    },
    true
  );

  function observe(el) {
    try {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            if (fired || suppressed) continue;
            fired = true;
            clar('ml_size_visible');
            io.disconnect();
          }
        },
        { threshold: THRESHOLD }
      );
      io.observe(el);
    } catch (e) {}
  }

  function boot() {
    clar('ml_pdp_view');
    var wrap = document.querySelector(SIZE_SEL);
    if (wrap) {
      observe(wrap);
      return;
    }
    /* pills can render after the variant picker hydrates */
    var poll = setInterval(function () {
      var w = document.querySelector(SIZE_SEL);
      if (w) {
        clearInterval(poll);
        observe(w);
      } else if (Date.now() > giveUpAt) {
        clearInterval(poll);
        clar('ml_size_absent');
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================================
   ME + LIA — REVIEW BADGE: SCROLL TO THE WIDGET (2026-08-03)

   THE BUG: tapping the Judge.me star badge under the product
   title appears to do nothing — measured scrollY 0 -> 0.

   THE CAUSE (found by reading templates/product.json, NOT by
   guessing): a custom-liquid section named `ml_review_expand`
   already listens for badge clicks and calls .click() on the
   "View reviews" pill. So the badge IS wired up — it EXPANDS
   the review widget. It just never MOVES THE VIEWPORT. And the
   widget lives in an `apps` section that renders AFTER
   `related-products`, i.e. below the entire "You may also like"
   carousel — so the thing it expands is far off screen and the
   shopper sees nothing happen.

   THEREFORE this block deliberately does NOT click the pill or
   touch expansion — ml_review_expand owns that, and duplicating
   it would double-fire. This ONLY scrolls. The two are
   complementary: that one opens, this one takes you there.

   Header offset is measured from the live sticky header rather
   than hard-coded, so it survives header height changes.

   ml_review_jump also settles an open question: Clarity has
   recorded ZERO taps of any kind on this badge, so we cannot
   currently tell "nobody taps it" from "taps go unrecorded".
   ============================================================ */
;(function () {
  if (window.__mlReviewScrollInit) return;
  window.__mlReviewScrollInit = true;

  if ((window.location.pathname || '').indexOf('/products/') === -1) return;

  function headerOffset() {
    try {
      var h = document.querySelector('sticky-header, .section-header, header.header-wrapper');
      if (!h) return 16;
      var r = h.getBoundingClientRect();
      return (r.height || 0) + 16;
    } catch (e) {
      return 16;
    }
  }

  function reviewsEl() {
    return (
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget')
    );
  }

  function scrollToReviews() {
    var el = reviewsEl();
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    if (window.scrollTo) {
      try {
        window.scrollTo({ top: y, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, y);
      }
    }
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.jdgm-prev-badge, [class*="jdgm-prev"]')) return;

      try {
        if (window.clarity) window.clarity('event', 'ml_review_jump');
      } catch (err) {}

      /* the widget can be lazy-mounted; retry briefly, stop on first success */
      var n = 0;
      var poll = setInterval(function () {
        n += 1;
        if (scrollToReviews() || n > 12) clearInterval(poll);
      }, 250);
    },
    true
  );
})();

/* ============================================================
   ME + LIA — GALLERY INTERACTION INSTRUMENT (2026-08-09)

   WHY: mobile taps are ~75-84% gallery navigation, one recording
   shows 47 thumbnail taps in under a minute, and a phone test
   confirmed pinch on the main image falls through to page-zoom
   (no gesture code anywhere in the theme — verified Aug 9).
   Before/alongside the sizes fix, these events quantify it:

     ml_gal_pinch — a 2-finger touch began on gallery media
                    (PDP gallery OR the zoom modal). Measures
                    INTENT — fires whether or not zoom responds.
                    Throttled to once per 800ms.
     ml_gal_open  — the zoom lightbox actually opened.
     ml_gal_thumb — a thumbnail tap (throttled 300ms so a
                    47-tap burst reads as intent, not 47 events).
     ml_gal_deep  — this session viewed a 4th distinct gallery
                    image (thumbnail targets + scroll positions
                    combined). Fires once per page.

   Read: pinch-heavy sessions with few ml_gal_open = shoppers
   trying to zoom and failing. ml_gal_deep without
   ml_size_visible = deep photo-browsing that never reaches the
   size row. All listeners passive + delegated — nothing here
   can block the gallery's native scroll.
   ============================================================ */
;(function () {
  if (window.__mlGalInstrInit) return;
  window.__mlGalInstrInit = true;

  if ((window.location.pathname || '').indexOf('/products/') === -1) return;

  function clar(name) {
    try {
      if (window.clarity) window.clarity('event', name);
    } catch (e) {}
  }

  var lastPinch = 0;
  document.addEventListener(
    'touchstart',
    function (e) {
      try {
        if (!e.touches || e.touches.length < 2) return;
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('media-gallery, product-modal, .product-media-modal')) return;
        var now = Date.now();
        if (now - lastPinch < 800) return;
        lastPinch = now;
        clar('ml_gal_pinch');
      } catch (err) {}
    },
    { passive: true, capture: true }
  );

  var lastThumb = 0;
  var seen = {};
  var seenCount = 0;
  var deepFired = false;

  function markSeen(key) {
    if (!key || seen[key]) return;
    seen[key] = true;
    seenCount += 1;
    if (!deepFired && seenCount >= 4) {
      deepFired = true;
      clar('ml_gal_deep');
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        var li = e.target.closest('media-gallery .thumbnail-list__item');
        if (!li) return;
        var now = Date.now();
        if (now - lastThumb >= 300) {
          lastThumb = now;
          clar('ml_gal_thumb');
        }
        markSeen('t:' + (li.getAttribute('data-target') || ''));
      } catch (err) {}
    },
    true
  );

  /* lightbox opens: watch for [open] landing on product-modal */
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.tagName === 'PRODUCT-MODAL' && t.hasAttribute('open')) {
          clar('ml_gal_open');
          return;
        }
      }
    }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  } catch (e) {}

  /* swipe-through depth: track which slide the scroll-snap gallery rests on */
  function bindScroll() {
    var list = document.querySelector('media-gallery ul.product__media-list');
    if (!list || list.__mlGalBound) return;
    list.__mlGalBound = true;
    markSeen('s:0');
    var timer = null;
    list.addEventListener(
      'scroll',
      function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          try {
            var w = list.clientWidth || 1;
            markSeen('s:' + Math.round(list.scrollLeft / w));
          } catch (e) {}
        }, 150);
      },
      { passive: true }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindScroll);
  } else {
    bindScroll();
  }
})();
